import * as React from 'react';
import cx from "classnames";

import './field-container.styles.scss';

export type FieldContainerProps = React.PropsWithChildren<{
  width: number;
  height: number;
  style?: React.CSSProperties;
  showBorder?: boolean;
  className?: string;
}>;

export const FieldContainer: React.FC<FieldContainerProps> = (props) => {
  const { children, style, className, width, height } = props;

  return (
    <div 
      style={{ ...style, width, height }}
      className={cx('DatasheetsResultFieldContainer', className)}
    >
      {children}
    </div>
  );
};